module.exports = __webpack_public_path__ + "static/media/93.d13b62e1.png";